import { useEffect, useState } from 'react';
import { currencyService } from '@/services/currencyService/currencyService';

export const useCurrencyConversion = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const convertAmount = async (
    amount: number,
    fromCurrency: string,
    toCurrency: string,
  ): Promise<number> => {
    return await currencyService.convertAmount(amount, fromCurrency, toCurrency);
  };

  const formatCurrency = (amount: number, currency: string): string => {
    return currencyService.formatCurrency(amount, currency);
  };

  return {
    loading,
    error,
    convertAmount,
    formatCurrency,
  };
};
